<template>
	<div class="scrollable only-y">
        <div :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="page-header card-base card-shadow--medium">
                <h2 class="no-m white-text">
                    Market
                </h2>
            </div>
        </div>
        <el-card>
            <el-tabs type="border-card" v-model="activeTab" v-loading="loadingPage">
                <el-tab-pane label="Area" name="area">
                    <el-row class="demo-form-inline">
                        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
                            <el-input
                                style="width:200px;"
                                class="mb-10"
                                size="mini"
                                placeholder="Market Name"
                                clearable
                                v-model="searchMarketArea"
                            />
                                    
                            <el-button-group class="mr-10 ml-10">
                                <el-button @click="getArea()" type="primary" round size="mini" class="animated fadeInRight" style="background-color: #0047FF;">
                                    <i class="el-icon-search"/>
                                </el-button>
                            </el-button-group>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
                            <el-button @click="addMarketAreaModal()" type="primary" size="mini" class="animated fadeInRight">
                                + Add Market Area
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" style="z-index: 0">
                        <el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card shadow="card-shadow--small">
                                <div class="group-list scrollable only-y">
                                    <el-pagination
                                        background
                                        prev-text="Prev"
                                        next-text="Next"
                                        layout="prev, pager, next"
                                        :page-size="20"
                                        @current-change="paginateAreaData"
                                        :current-page="currentPage"
                                        :total="parseInt(totalAreaData)">
                                    </el-pagination>
                                    <template>
                                        <el-table style="width: 100%; color: #000 !important" v-loading="loadingTable" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(246, 246, 245, 0.8)" :data="areaData">
                                            <!-- <el-table-column type="index" width="100" label="#" :rowspan="2">
                                                <template slot-scope="props">
                                                    <p style="font-weight:bold;">{{ props.$index + 1 }}</p>
                                                </template>
                                            </el-table-column> -->
                                            <el-table-column width="200" label="Market Name" :rowspan="2">
                                                <template slot-scope="props">
                                                    <p style="font-weight:bold;">{{ props.row.name }}</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="150" label="Market Prefix" :rowspan="2">
                                                <template slot-scope="props">
                                                    <p style="font-weight:bold;">{{ props.row.master_prefixs.length }}</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="150" label="Price Type">
                                                <template slot-scope="props">
                                                    <p style="font-weight:bold;">META</p>
                                                    <p style="font-weight:bold;">DAMCORP</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Authentication" width="150">
                                                <template slot-scope="props">
                                                    <p v-if="props.row && props.row.market_meta_price" style="font-weight:bold;">{{ props.row && props.row.market_meta_price && props.row.market_meta_price.authentication_price ? formatPrice(props.row.market_meta_price.authentication_price) : '0' }}</p>
                                                    <p v-else>-</p>
                                                    <p v-if="props.row && props.row.market_dkd_price" style="font-weight:bold;">{{ props.row && props.row.market_dkd_price && props.row.market_dkd_price.authentication_price ? formatPrice(props.row.market_dkd_price.authentication_price) : '0' }}</p>
                                                    <p v-else>-</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Marketing" width="150">
                                                <template slot-scope="props">
                                                    <p v-if="props.row.market_meta_price" style="font-weight:bold;">{{ props.row && props.row.market_meta_price && props.row.market_meta_price.marketing_price ? formatPrice(props.row.market_meta_price.marketing_price) : '0' }}</p>
                                                    <p v-else>-</p>
                                                    <p v-if="props.row.market_dkd_price" style="font-weight:bold;">{{ props.row && props.row.market_dkd_price && props.row.market_dkd_price.marketing_price ? formatPrice(props.row.market_dkd_price.marketing_price) : '0' }}</p>
                                                    <p v-else>-</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Utility" align="center" width="100">
                                                <template slot-scope="props">
                                                    <p v-if="props.row && props.row.market_meta_price" style="font-weight:bold;">{{ props.row && props.row.market_meta_price && props.row.market_meta_price.utility_price ? formatPrice(props.row.market_meta_price.utility_price) : '0' }}</p>
                                                    <p v-else>-</p>
                                                    <p v-if="props.row && props.row.market_dkd_price" style="font-weight:bold;">{{ props.row && props.row.market_dkd_price && props.row.market_dkd_price.utility_price ? formatPrice(props.row.market_dkd_price.utility_price) : '0' }}</p>
                                                    <p v-else>-</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Service" align="center" width="100">
                                                <template slot-scope="props">
                                                    <p v-if="props.row && props.row.market_meta_price" style="font-weight:bold;">{{ props.row && props.row.market_meta_price && props.row.market_meta_price.service_price ? formatPrice(props.row.market_meta_price.service_price) : '0' }}</p>
                                                    <p v-else>-</p>
                                                    <p v-if="props.row && props.row.market_dkd_price" style="font-weight:bold;">{{ props.row && props.row.market_dkd_price && props.row.market_dkd_price.service_price ? formatPrice(props.row.market_dkd_price.service_price) : '0' }}</p>
                                                    <p v-else>-</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Status" align="center" width="100">
                                                <template slot-scope="props">
                                                    <p style="font-weight:bold;">{{ props.row.status ? 'Active' : 'Not Active' }}</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Action" align="center" width="400">
                                                <template slot-scope="props">
                                                    <el-button @click="toManagePrefix(props.row.id, props.row.name)" type="primary" size="mini">
                                                        Manage Prefix
                                                    </el-button>
                                                    <el-button type="primary" size="mini" @click="detailMarketArea(props.row.id)">
                                                        Edit
                                                    </el-button>
                                                    <el-button @click="deleteArea(props.row.id, props.row.name)" type="danger" size="mini" :disabled="props.row.master_prefixs.length > 0 ? true : false">
                                                        Delete
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </template>
                                    <el-pagination
                                        background
                                        prev-text="Prev"
                                        next-text="Next"
                                        layout="prev, pager, next"
                                        :page-size="20"
                                        @current-change="paginateAreaData"
                                        :current-page="currentPage"
                                        :total="parseInt(totalAreaData)">
                                    </el-pagination>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="Discount Price WABA" name="discpricewaba">
                    <el-row class="mb-10" style="font-size:14px;">
                        <el-col :span="4" :md="7" :sm="7" :xs="7" justify="end">
                            <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                                <span style="font-size:14px;">To expire in 3 months</span><br><br>
                                <span style="font-size:34px;">
                                    {{ wabaSummary && wabaSummary.expiredInThreeMonth ? wabaSummary.expiredInThreeMonth : 0 }}
                                </span>
                            </el-card>
                        </el-col>
                        <el-col :span="4" :md="7" :sm="7" :xs="7" justify="end">
                            <el-card style="background-color:#8CBC26; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                                <span style="font-size:14px;">To expire in 2 months</span><br><br>
                                <span style="font-size:34px;">
                                    {{ wabaSummary && wabaSummary.expiredInTwoMonth ? wabaSummary.expiredInTwoMonth : 0 }}
                                </span>
                            </el-card>
                        </el-col>
                        <el-col :span="4" :md="7" :sm="7" :xs="7" justify="end">
                            <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                                <span style="font-size:14px;">To expire in 1 month</span><br><br>
                                <span style="font-size:34px;">
                                    {{ wabaSummary && wabaSummary.expiredInOneMonth ? wabaSummary.expiredInOneMonth : 0 }}
                                </span>
                            </el-card>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xl="18" :lg="18" :md="24" :sm="24" :xs="24" justify="end">
                            <template>    
                                <el-select placeholder="Periode Limit" v-model="filterPeriode" style="width:130px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                        v-for="(items, idx) in selectPeriodeLimit"
                                        :key="idx"
                                        :label="items.name"
                                        :value="items.value"
                                    ></el-option>
                                </el-select>
                                
                                <el-select placeholder="Discount Name" v-model="filterWabaId" style="width:130px;" size="mini" :default-first-option="true" class="mb-10 mr-5" clearable>
                                    <el-option
                                        v-for="items in discListWaba"
                                        :key="items.id"
                                        :label="items.name ? items.name : '-'"
                                        :value="items.waba_phone_number"
                                    ></el-option>
                                </el-select>
        
                                <el-input
                                    style="width:200px;"
                                    class="mb-10"
                                    size="mini"
                                    prefix-icon="el-icon-search"
                                    placeholder="Search"
                                    clearable
                                    v-model="filterDiscName"
                                />
                                
                                <el-button-group class="mr-10 ml-10">
                                    <el-button type="primary" round size="mini" class="animated fadeInRight" style="background-color: #0047FF;" @click="getDisc(1, 'waba')" :loading="btnSearchLoading">
                                        <i class="el-icon-search"/>
                                    </el-button>
                                </el-button-group>
                            </template>
                        </el-col>
                        <el-col :xl="6" :lg="6" :md="24" :sm="24" :xs="24" justify="end">
                            <el-button type="primary" size="mini" class="animated fadeInRight" @click="addWabaDiscount()">
                                + Add WABA Discount
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" style="z-index: 0">
                        <el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card shadow="card-shadow--small">
                                <div class="group-list scrollable only-y">
                                    <el-pagination
                                        background
                                        prev-text="Prev"
                                        next-text="Next"
                                        layout="prev, pager, next"
                                        @current-change="paginateWabaData"
                                        :current-page="currentPageWaba"
                                        :total="parseInt(totalWabaData)"
                                        :page-size="20">
                                    </el-pagination>
                                    <template>
                                        <el-table style="width: 100%; color: #000 !important" v-loading="loadingTable" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(246, 246, 245, 0.8)" :data="discWabaData">
                                            <el-table-column width="200" label="WABA ID">
                                                <template slot-scope="props">
                                                    <p style="font-weight:bold;">{{ props.row.waba_phone_number ? props.row.waba_phone_number : '-' }}</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="300" label="Discount Name">
                                                <template slot-scope="props">
                                                    <p style="font-weight:bold;">{{ props.row.name ? props.row.name : '-' }}</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="300" label="Range Period Limit">
                                                <template slot-scope="props">
                                                    <p style="font-weight:bold;">{{ props.row.start_period + ' to ' + props.row.end_period }}</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Document" width="300">
                                                <template slot-scope="props">
                                                    <p v-if="!props.row.media">-</p>
                                                    <a :href="props.row.media.full_url" v-else-if="props.row.media" style="font-weight:bold;" target="_blank">{{ props.row.media && props.row.media.file_name ? props.row.media.file_name : '-' }}</a>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="List Market Area" align="center" width="300">
                                                <template slot-scope="props">
                                                    <p v-for="item in props.row.master_discount_markets">
                                                        <span style="font-weight:bold;">{{ item.master_market_area ? item.master_market_area.name : '-' }}</span>
                                                    </p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Action" align="center" width="300">
                                                <template slot-scope="props">
                                                    <el-button type="primary" size="mini" @click="detailPhoneWaba(props.row.id, 'waba')">
                                                        Detail
                                                    </el-button>
                                                    <el-button @click="deleteDiscWabaPhone(props.row.id, props.row.name, 'waba')" type="danger" size="mini">Delete</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </template>
                                    <el-pagination
                                        background
                                        prev-text="Prev"
                                        next-text="Next"
                                        layout="prev, pager, next"
                                        @current-change="paginateWabaData"
                                        :current-page="currentPageWaba"
                                        :total="parseInt(totalWabaData)"
                                        :page-size="20">
                                    </el-pagination>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="Discount By Phone Number" name="discbyphone">
                    <el-row class="mb-10" style="font-size:14px;">
                        <el-col :span="4" :md="7" :sm="7" :xs="7" justify="end">
                            <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                                <span style="font-size:14px;">To expire in 3 months</span><br><br/>
                                <span style="font-size:34px;">
                                    {{ phoneNumberSummary && phoneNumberSummary.expiredInThreeMonth ? phoneNumberSummary.expiredInThreeMonth : 0 }}
                                </span>
                            </el-card>
                        </el-col>
                        <el-col :span="4" :md="7" :sm="7" :xs="7" justify="end">
                            <el-card style="background-color:#8CBC26; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                                <span style="font-size:14px;">To expire in 2 months</span><br><br>
                                <span style="font-size:34px;">
                                    {{ phoneNumberSummary && phoneNumberSummary.expiredInTwoMonth ? phoneNumberSummary.expiredInTwoMonth : 0 }}
                                </span>
                            </el-card>
                        </el-col>
                        <el-col :span="4" :md="7" :sm="7" :xs="7" justify="end">
                            <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word; text-align: center;" class="mb-10">
                                <span style="font-size:14px;">To expire in 1 month</span><br><br>
                                <span style="font-size:34px;">
                                    {{ phoneNumberSummary && phoneNumberSummary.expiredInOneMonth ? phoneNumberSummary.expiredInOneMonth : 0 }}
                                </span>
                            </el-card>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xl="19" :lg="19" :md="24" :sm="24" :xs="24" justify="end">
                            <template>
                                <el-select placeholder="Periode Limit" v-model="filterPeriodePhoneNumber" style="width:130px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                        v-for="(items, idx) in selectPeriodeLimitPhoneNumber"
                                        :key="idx"
                                        :label="items.name"
                                        :value="items.value"
                                    ></el-option>
                                </el-select>
        
                                <el-select
                                    placeholder="Company Name"
                                    style="width:130px;"
                                    size="mini"
                                    :default-first-option="true"
                                    class="mb-10 mr-5"
                                    v-model="filterCompanyNameByPhone"
                                    clearable
                                    @change="companySelected"
                                    filterable
                                >
                                    <el-option
                                        v-for="items in listCustomer"
                                        :key="items.customer_id"
                                        :label="items.customer_name"
                                        :value="items.customer_id"
                                    ></el-option>
                                </el-select>

                                <el-select placeholder="Phone Number" style="width:130px;" size="mini" :default-first-option="true" class="mb-10 mr-5" v-model="filterPhoneNumberByPhone" clearable :disabled="!filterCompanyNameByPhone">
                                    <el-option
                                        v-for="(items, idx) in listPhoneNumber"
                                        :key=idx
                                        :label="items"
                                        :value="items"
                                    ></el-option>
                                </el-select>
        
                                <el-input
                                    style="width:170px;"
                                    class="mb-10"
                                    size="mini"
                                    prefix-icon="el-icon-search"
                                    placeholder="Discount Name"
                                    clearable
                                    v-model="filterDiscNameByPhone"
                                />
                                
                                <el-button-group class="mr-10 ml-10">
                                    <el-button type="primary" round size="mini" class="animated fadeInRight" style="background-color: #0047FF;" @click="getDisc(1, 'phone_number')" :loading="btnSearchLoading">
                                        <i class="el-icon-search"/>
                                    </el-button>
                                </el-button-group>
                            </template>
                        </el-col>
                        <el-col :xl="5" :lg="5" :md="24" :sm="24" :xs="24" justify="end">
                            <el-button @click="addPhoneDiscModal()" type="primary" size="mini" class="animated fadeInRight">
                                + Add Phone Discount
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" style="z-index: 0">
                        <el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card shadow="card-shadow--small">
                                <div class="group-list scrollable only-y">
                                    <el-pagination
                                        background
                                        prev-text="Prev"
                                        next-text="Next"
                                        layout="prev, pager, next"
                                        @current-change="paginatePhoneData"
                                        :current-page="currentPagePhone"
                                        :total="parseInt(totalPhoneData)"
                                        :page-size="20">
                                    </el-pagination>
                                    <template>
                                        <el-table style="width: 100%; color: #000 !important" v-loading="loadingTable" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(246, 246, 245, 0.8)" :data="discPhoneNumberData">
                                            <el-table-column width="300" label="Company Name">
                                                <template slot-scope="props">
                                                    <p style="font-weight:bold;">{{ props.row.customer ? props.row.customer.customer_name : '-' }}</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="200" label="Phone Number">
                                                <template slot-scope="props">
                                                    <p style="font-weight:bold;">{{ props.row.waba_phone_number ? props.row.waba_phone_number : '-' }}</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="300" label="Discount Name">
                                                <template slot-scope="props">
                                                    <p style="font-weight:bold;">{{ props.row.name ? props.row.name : '-' }}</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Range Period Limit" width="400">
                                                <template slot-scope="props">
                                                    <p style="font-weight:bold;">{{ `${props.row.start_period ? props.row.start_period : '-'}` + ' to ' + `${props.row.end_period ? props.row.end_period : '-'}` }}</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Discount Type" width="200">
                                                <template slot-scope="props">
                                                    <p>-</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Document" width="300">
                                                <template slot-scope="props">
                                                    <p v-if="!props.row.media">-</p>
                                                    <a :href="props.row.media.full_url" v-else-if="props.row.media" style="font-weight:bold;" target="_blank">{{ props.row.media && props.row.media.file_name ? props.row.media.file_name : '-' }}</a>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Market Area" align="center" width="130">
                                                <template slot-scope="props">
                                                    <div v-if="props.row.master_discount_markets.length > 0" v-for="item in props.row.master_discount_markets">
                                                        <span style="font-weight:bold;">{{ item.master_market_area ? item.master_market_area.name : '-' }}</span>
                                                    </div>
                                                    <p v-else>-</p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="Action" align="center" width="300">
                                                <template slot-scope="props">
                                                    <el-button type="primary" size="mini" @click="detailPhoneWaba(props.row.id, 'phone_number')">
                                                        Detail
                                                    </el-button>
                                                    <el-button @click="deleteDiscWabaPhone(props.row.id, props.row.name, 'phone_number')" type="danger" size="mini">Delete</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </template>
                                    <el-pagination
                                        background
                                        prev-text="Prev"
                                        next-text="Next"
                                        layout="prev, pager, next"
                                        @current-change="paginatePhoneData"
                                        :current-page="currentPagePhone"
                                        :total="parseInt(totalPhoneData)"
                                        :page-size="20">
                                    </el-pagination>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </el-card>

        <!-- modal dialog detail discount waba -->
        <el-dialog title="Detail Discount WABA" :visible.sync="dialogDetailDiscountWaba" v-loading="loadingDetailDiscountPriceWaba" id="html-2-pdfwrapper" width="65%">
            <el-row>
                <el-card class="mb-5">
                    <el-form label-width="150px">
                        <el-form-item label="WABA ID">
                            <el-input :value="detailWaba.waba_phone_number ? detailWaba.waba_phone_number : '-'" disabled/>
                        </el-form-item>
                        <el-form-item label="Discount Name">
                            <el-input :value="detailWaba.name ? detailWaba.name : '-'" disabled/>
                        </el-form-item>
                        <el-form-item label="Range Period Limit">
                            <el-input :value="detailWaba.start_period + ' to ' + detailWaba.end_period" disabled/>
                        </el-form-item>
                        <el-form-item label="Document">
                            <el-input :value="detailWaba && detailWaba.media ? detailWaba.media.file_name : '-'" disabled/>
                        </el-form-item>
                    </el-form>
                </el-card>
                <el-card class="mt-20">
                    <template>
                        <h3 class="mb-10">List Market Area</h3>
                        <el-card
                            v-for="(item, idx) in detailWaba.master_discount_markets"
                            :key="idx"
                            class="mb-10"
                        >
                            <el-form :inline="true" label-position="top" class="demo-form-inline">
                                <el-form-item label="Market Area" class="mb-5 mr-5">
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="item.master_market_area.name"
                                    />
                                </el-form-item>
                                <el-form-item label="Authentication" class="mb-5 mr-5">
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="`${item.master_discount_market_detail_amount.authentication_type === 'precentage' ? '%' : 'Rp'} ${item.master_discount_market_detail_amount.authentication_amount}`"
                                    /><br/>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="formatPrice(item.master_discount_market_detail_amount.authentication_price_after_discount)"
                                    />
                                </el-form-item>
                                <el-form-item label="Marketing" class="mb-5 mr-5">
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="`${item.master_discount_market_detail_amount.marketing_type === 'precentage' ? '%' : 'Rp'} ${item.master_discount_market_detail_amount.marketing_amount}`"
                                    /><br/>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="formatPrice(item.master_discount_market_detail_amount.marketing_price_after_discount)"
                                    />
                                </el-form-item>
                                <el-form-item label="Utility" class="mb-5 mr-5">
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="`${item.master_discount_market_detail_amount.utility_type === 'precentage' ? '%' : 'Rp'} ${item.master_discount_market_detail_amount.utility_amount}`"
                                    /><br/>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="formatPrice(item.master_discount_market_detail_amount.utility_price_after_discount)"
                                    />
                                </el-form-item>
                                <el-form-item label="Service" class="mb-5 mr-5">
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="`${item.master_discount_market_detail_amount.service_type === 'precentage' ? '%' : 'Rp'} ${item.master_discount_market_detail_amount.service_amount}`"
                                    /><br/>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="formatPrice(item.master_discount_market_detail_amount.service_price_after_discount)"
                                    />
                                </el-form-item>
                            </el-form>
                        </el-card>
                    </template>
                </el-card>
                <el-card class="mt-20">
                    <el-form label-width="120px">
                        <el-form-item label="Created Date">
                            <el-input :value="detailWaba.created_at ? formatDate(detailWaba.created_at) : '-'" disabled/>
                        </el-form-item>
                        <el-form-item label="Created By">
                            <el-input :value="detailWaba && detailWaba.admin && detailWaba.admin.username ? detailWaba.admin.username : '-'" disabled/>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-row>
        </el-dialog>

        <!-- modal dialog add discount waba -->
        <el-dialog title="Add Discount WABA" :visible.sync="dialogAddDiscountWaba" v-loading="loadingDetailAddPriceWaba" id="html-2-pdfwrapper" width="70%">
            <el-row>
                <el-card class="mb-5">
                    <el-form label-width="150px">
                        <el-form-item label="WABA ID">
                            <el-select v-model="addDiscWaba.waba_phone_number" filterable placeholder="Select WABA ID" style="width:350px">
                                <el-option
                                    v-for="(item, key) in fbIdentityWaba"
                                    :key="key"
                                    :label="item.maskingName || '-'"
                                    :value="item.identityNumber"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Discount Name">
                            <el-input v-model="addDiscWaba.discName" style="width:350px" placeholder="Discount Name" />
                        </el-form-item>
                        <el-form-item label="Range Period Limit">
                            <el-date-picker
                                v-model="addDiscWaba.selectedStartDate"
                                type="monthrange"
                                range-separator="To"
                                start-placeholder="Start month"
                                end-placeholder="End month"
                                style="width: 350px;"
                            />
                        </el-form-item>
                        <el-form-item label="Document">
                            <el-upload
                                class="upload-demo"
                                id="inputMedia"
                                :http-request="renderMedia"
                                action=""
                                :on-preview="handlePreview"
                                :before-upload="beforeUploadMedia"
                                :on-remove="handleRemove"
                                :before-remove="beforeRemove"
                                drag
                                list-type="text"
                                :limit="1"
                                :on-exceed="handleExceed"
                            >
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text" @click="renderMedia">Drop file here or <em>click to upload</em></div>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </el-card>
                <el-card class="mt-20">
                    <template>
                        <h3 class="mb-10">List Market Area</h3>
                        <el-card
                            v-for="(item, idx) in addDiscWaba.master_discount_markets"
                            :key="idx"
                            class="mb-10"
                        >
                            <el-row>
                                <el-col :xs="23" :sm="23" :md="23" :lg="23" :xl="23">
                                    <el-form
                                        :inline="true"
                                        label-position="top"
                                        class="demo-form-inline"
                                    >
                                        <el-form-item label="Market Area" class="mb-5 mr-5">
                                            <el-select v-model="addDiscWaba.master_discount_markets[idx].master_market_area_id" @change="selectedAreaWabaPhone('waba', idx)" style="width:150px;" size="medium">
                                                <el-option
                                                    v-for="(item, idx) in listAreaData"
                                                    :label="item.name"
                                                    :value="item.id"
                                                    :key="idx"
                                                    :disabled="isChoosedMarket(item, 'waba')"
                                                />
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="Authentication" class="mb-5 mr-5">
                                            <el-select v-model="item.master_discount_market_detail_amount.authentication_type" style="width:150px;" size="medium" :disabled="!addDiscWaba.master_discount_markets[idx].master_market_area_id" @change="clearInputCurrency('waba', 'addAuth', idx)">
                                                <el-option
                                                    v-for="(item, idx) in optionListMarket"
                                                    :label="item.name"
                                                    :value="item.value"
                                                    :key="idx"
                                                />
                                            </el-select><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                @keypress.native="numberOnly"
                                                @change="calculation('waba', item.master_discount_market_detail_amount.disc_authentication_amount, item.master_discount_market_detail_amount.authentication_type, idx, addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.authentication_amount, 'authentication')"
                                                v-model="item.master_discount_market_detail_amount.disc_authentication_amount"
                                                :disabled="!addDiscWaba.master_discount_markets[idx].master_market_area_id || !addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.authentication_type"
                                            /><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                :value="formatPrice(areaWaba.length > 0 ? areaWaba[idx].market_dkd_price.authentication_price : 0)"
                                                disabled
                                            />
                                        </el-form-item>
                                        <el-form-item label="Marketing" class="mb-5 mr-5">
                                            <el-select v-model="item.master_discount_market_detail_amount.marketing_type" style="width:150px;" size="medium" :default-first-option="true" :disabled="!addDiscWaba.master_discount_markets[idx].master_market_area_id" @change="clearInputCurrency('waba', 'addMarketing', idx)">
                                                <el-option
                                                    v-for="(item, idx) in optionListMarket"
                                                    :label="item.name"
                                                    :value="item.value"
                                                    :key="idx"
                                                />
                                            </el-select><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                @keypress.native="numberOnly"
                                                @change="calculation('waba', item.master_discount_market_detail_amount.disc_marketing_amount, item.master_discount_market_detail_amount.marketing_type, idx, addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.marketing_amount, 'marketing')"
                                                v-model="item.master_discount_market_detail_amount.disc_marketing_amount"
                                                :disabled="!addDiscWaba.master_discount_markets[idx].master_market_area_id || !addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.marketing_type"
                                            /><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                :value="formatPrice(areaWaba.length > 0 ? areaWaba[idx].market_dkd_price.marketing_price : 0)"
                                                disabled
                                            />
                                        </el-form-item>
                                        <el-form-item label="Utility" class="mb-5 mr-5">
                                            <el-select v-model="item.master_discount_market_detail_amount.utility_type" style="width:150px;" size="medium" :default-first-option="true" :disabled="!addDiscWaba.master_discount_markets[idx].master_market_area_id" @change="clearInputCurrency('waba', 'addUtility', idx)">
                                                <el-option
                                                    v-for="(item, idx) in optionListMarket"
                                                    :label="item.name"
                                                    :value="item.value"
                                                    :key="idx"
                                                />
                                            </el-select><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                @keypress.native="numberOnly"
                                                @change="calculation('waba', item.master_discount_market_detail_amount.disc_utility_amount, item.master_discount_market_detail_amount.utility_type, idx, addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.utility_amount, 'utility')"
                                                v-model="item.master_discount_market_detail_amount.disc_utility_amount"
                                                :disabled="!addDiscWaba.master_discount_markets[idx].master_market_area_id || !addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.utility_type"
                                            /><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                :value="formatPrice(areaWaba.length > 0 ? areaWaba[idx].market_dkd_price.utility_price : 0)"
                                                disabled
                                            />
                                        </el-form-item>
                                        <el-form-item label="Service" class="mb-5 mr-5">
                                            <el-select v-model="item.master_discount_market_detail_amount.service_type" style="width:150px;" size="medium" :default-first-option="true" :disabled="!addDiscWaba.master_discount_markets[idx].master_market_area_id" @change="clearInputCurrency('waba', 'addService', idx)">
                                                <el-option
                                                    v-for="(item, idx) in optionListMarket"
                                                    :label="item.name"
                                                    :value="item.value"
                                                    :key="idx"
                                                />
                                            </el-select><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                @keypress.native="numberOnly"
                                                @change="calculation('waba', item.master_discount_market_detail_amount.disc_service_amount, item.master_discount_market_detail_amount.service_type, idx, addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.service_amount, 'service')"
                                                v-model="item.master_discount_market_detail_amount.disc_service_amount"
                                                :disabled="!addDiscWaba.master_discount_markets[idx].master_market_area_id || !addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.service_type"
                                            /><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                :value="formatPrice(areaWaba.length > 0 ? areaWaba[idx].market_dkd_price.service_price : 0)"
                                                disabled
                                            />
                                        </el-form-item>
                                    </el-form>
                                </el-col>
                                <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                                    <el-button class="mr-30" v-if="addDiscWaba.master_discount_markets.length > 1 && idx !== 0" type="danger" size="mini" @click="deleteMarketAreaDisc(idx, 'waba')">
                                        <i class="mdi mdi-delete-forever"></i> 
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-card>
                    </template>
                    <el-row v-if="addDiscWaba.master_discount_markets.length < areaData.length" class="mt-20">
                        <el-button
                            @click="addMarketDiscPhoneWaba('waba')"
                            style="width: 100%;"
                            type="primary"
                            :disabled="isMarketSelected('waba')"
                        >
                            + Add Market Area
                        </el-button>
                    </el-row>
                </el-card>
            </el-row>
            <el-row class="mt-20">
                <el-button :loading="loadingBtnAddWaba" type="primary" @click="createDiscWabaPhone('waba')">Save</el-button>
                <el-button @click="cancelDialog('waba')" type="danger">Cancel</el-button>
            </el-row>
        </el-dialog>

        <!-- modal dialog add discount by phone -->
        <el-dialog title="Add Discount by Phone Number" :visible.sync="dialogAddDiscountPhone" v-loading="loadingDetailAddDiscountPhone" id="html-2-pdfwrapper" width="70%">
            <el-row>
                <el-card class="mb-5">
                    <el-form label-width="150px">
                        <el-form-item label="Company Name">
                            <el-select
                                v-model="selectCompanyPhone"
                                @change="companySelected"
                                style="width:350px;"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="Please select company name"
                                remote-show-suffix
                            >
                                <el-option
                                    v-for="(item, idx) in consumenData"
                                    :label="item.customer_name"
                                    :value="item.customer_id"
                                    :key="idx"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Phone Number">
                            <el-select v-model="addDiscPhone.waba_phone_number" style="width:350px;" :default-first-option="true" class="mr-5">
                                <el-option
                                    v-for="(item, idx) in listPhoneNumber"
                                    :label="item"
                                    :value="item"
                                    :key="idx"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Discount Name">
                            <el-input v-model="addDiscPhone.discName" style="width:350px;" placeholder="Discount Name"/>
                        </el-form-item>
                        <el-form-item label="Range Period limit">
                            <el-date-picker
                                v-model="addDiscPhone.selectedStartDate"
                                type="monthrange"
                                range-separator="To"
                                start-placeholder="Start month"
                                end-placeholder="End month"
                                style="width: 350px;"
                            />
                        </el-form-item>
                        <el-form-item label="Document">
                            <el-upload
                                class="upload-demo"
                                id="inputMedia"
                                :http-request="renderMedia"
                                action=""
                                :on-preview="handlePreview"
                                :before-upload="beforeUploadMedia"
                                :on-remove="handleRemove"
                                :before-remove="beforeRemove"
                                drag
                                list-type="text"
                                :limit="1"
                                :on-exceed="handleExceed"
                            >
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text" @click="renderMedia">Drop file here or <em>click to upload</em></div>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </el-card>
                <el-card class="mt-20">
                    <template>
                        <h3 class="mb-10">List Market Area</h3>
                        <el-card
                            v-for="(item, idx) in addDiscPhone.master_discount_markets"
                            :key="idx"
                            class="mb-10"
                        >
                            <el-row>
                                <el-col :xs="23" :sm="23" :md="23" :lg="23" :xl="23">
                                    <el-form
                                        :inline="true"
                                        label-position="top"
                                        class="demo-form-inline"
                                    >
                                        <el-form-item label="Market Area" class="mb-5 mr-5">
                                            <el-select v-model="addDiscPhone.master_discount_markets[idx].master_market_area_id" @change="selectedAreaWabaPhone('phone_number', idx)" style="width:150px;" size="medium">
                                                <el-option
                                                    v-for="(item, idx) in listAreaData"
                                                    :label="item.name"
                                                    :value="item.id"
                                                    :key="idx"
                                                    :disabled="isChoosedMarket(item, 'phone')"
                                                />
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="Authentication" class="mb-5 mr-5">
                                            <el-select v-model="item.master_discount_market_detail_amount.authentication_type" style="width:150px;" size="medium" :disabled="!addDiscPhone.master_discount_markets[idx].master_market_area_id" @change="clearInputCurrency('phone', 'addAuth', idx)">
                                                <el-option
                                                    v-for="(item, idx) in optionListMarket"
                                                    :label="item.name"
                                                    :value="item.value"
                                                    :key="idx"
                                                />
                                            </el-select><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                @keypress.native="numberOnly"
                                                @change="calculation('phone_number', item.master_discount_market_detail_amount.disc_authentication_amount, item.master_discount_market_detail_amount.authentication_type, idx, addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.authentication_amount, 'authentication')"
                                                v-model="addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.disc_authentication_amount"
                                                :disabled="!addDiscPhone.master_discount_markets[idx].master_market_area_id || !addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.authentication_type"
                                            /><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                :value="formatPrice(areaPhone.length > 0 ? areaPhone[idx].market_dkd_price.authentication_price : 0)"
                                                disabled
                                            />
                                        </el-form-item>
                                        <el-form-item label="Marketing" class="mb-5 mr-5">
                                            <el-select v-model="item.master_discount_market_detail_amount.marketing_type" style="width:150px;" size="medium" :default-first-option="true" :disabled="!addDiscPhone.master_discount_markets[idx].master_market_area_id" @change="clearInputCurrency('phone', 'addMarketing', idx)">
                                                <el-option
                                                    v-for="(item, idx) in optionListMarket"
                                                    :label="item.name"
                                                    :value="item.value"
                                                    :key="idx"
                                                />
                                            </el-select><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                @keypress.native="numberOnly"
                                                @change="calculation('phone_number', item.master_discount_market_detail_amount.disc_marketing_amount, item.master_discount_market_detail_amount.marketing_type, idx, addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.marketing_amount, 'marketing')"
                                                v-model="addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.disc_marketing_amount"
                                                :disabled="!addDiscPhone.master_discount_markets[idx].master_market_area_id || !addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.marketing_type"
                                            /><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                :value="formatPrice(areaPhone.length > 0 ? areaPhone[idx].market_dkd_price.marketing_price : 0)"
                                                disabled
                                            />
                                        </el-form-item>
                                        <el-form-item label="Utility" class="mb-5 mr-5">
                                            <el-select v-model="item.master_discount_market_detail_amount.utility_type" style="width:150px;" size="medium" :default-first-option="true" :disabled="!addDiscPhone.master_discount_markets[idx].master_market_area_id" @change="clearInputCurrency('phone', 'addUtility', idx)">
                                                <el-option
                                                    v-for="(item, idx) in optionListMarket"
                                                    :label="item.name"
                                                    :value="item.value"
                                                    :key="idx"
                                                />
                                            </el-select><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                @keypress.native="numberOnly"
                                                @change="calculation('phone_number', item.master_discount_market_detail_amount.disc_utility_amount, item.master_discount_market_detail_amount.utility_type, idx, addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.utility_amount, 'utility')"
                                                v-model="addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.disc_utility_amount"
                                                :disabled="!addDiscPhone.master_discount_markets[idx].master_market_area_id || !addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.utility_type"
                                            /><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                :value="formatPrice(areaPhone.length > 0 ? areaPhone[idx].market_dkd_price.utility_price : 0)"
                                                disabled
                                            />
                                        </el-form-item>
                                        <el-form-item label="Service" class="mb-5 mr-5">
                                            <el-select v-model="item.master_discount_market_detail_amount.service_type" style="width:150px;" size="medium" :default-first-option="true" :disabled="!addDiscPhone.master_discount_markets[idx].master_market_area_id" @change="clearInputCurrency('phone', 'addService', idx)">
                                                <el-option
                                                    v-for="(item, idx) in optionListMarket"
                                                    :label="item.name"
                                                    :value="item.value"
                                                    :key="idx"
                                                />
                                            </el-select><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                @keypress.native="numberOnly"
                                                @change="calculation('phone_number', item.master_discount_market_detail_amount.disc_service_amount, item.master_discount_market_detail_amount.service_type, idx, addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.service_amount, 'service')"
                                                v-model="addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.disc_service_amount"
                                                :disabled="!addDiscPhone.master_discount_markets[idx].master_market_area_id || !addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.service_type"
                                            /><br/>
                                            <el-input
                                                type="text"
                                                size="medium"
                                                style="width:150px;"
                                                :value="formatPrice(areaPhone.length > 0 ? areaPhone[idx].market_dkd_price.service_price : 0)"
                                                disabled
                                            />
                                        </el-form-item>
                                    </el-form>
                                </el-col>
                                <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                                    <el-button
                                        class="mr-30"
                                        v-if="addDiscPhone.master_discount_markets.length > 1 && idx !== 0" type="danger"
                                        size="mini"
                                        @click="deleteMarketAreaDisc(idx, 'phone_number')"
                                    >
                                        <i class="mdi mdi-delete-forever"></i> 
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-card>
                    </template>
                    <el-row v-if="addDiscPhone.master_discount_markets.length < areaData.length" class="mt-20">
                        <el-button
                            @click="addMarketDiscPhoneWaba('phone_number')"
                            style="width: 100%;"
                            type="primary"
                            :disabled="isMarketSelected('phone')"
                        >
                            + Add Market Area
                        </el-button>
                    </el-row>
                </el-card>
            </el-row>
            <el-row class="mt-20">
                <el-button :loading="loadingBtnAddPhone" type="primary" @click="createDiscWabaPhone('phone_number')">Save</el-button>
                <el-button @click="cancelDialog('phone_number')" type="danger">Cancel</el-button>
            </el-row>
        </el-dialog>

        <!-- modal dialog detail discount by phone number -->
        <el-dialog title="Detail Discount By Phone Number" :visible.sync="dialogDetailDiscountPhone" v-loading="loadingDetailDiscountPhone" id="html-2-pdfwrapper" width="65%">
            <el-row>
                <el-card class="mb-5">
                    <el-form label-width="150px">
                        <el-form-item label="Company Name">
                            <el-input :value="detailPhone.customer && detailPhone.customer.customer_name ? detailPhone.customer.customer_name : '-'" disabled/>
                        </el-form-item>
                        <el-form-item label="Phone Number">
                            <el-input :value="detailPhone.waba_phone_number ? detailPhone.waba_phone_number : '-'" disabled/>
                        </el-form-item>
                        <el-form-item label="Discount Name">
                            <el-input :value="detailPhone.name ? detailPhone.name : '-'" disabled/>
                        </el-form-item>
                        <el-form-item label="Range Period Limit">
                            <el-input :value="detailPhone.start_period + ' to ' + detailPhone.end_period" disabled/>
                        </el-form-item>
                        <el-form-item label="Document">
                            <el-input :value="detailPhone && detailPhone.media && detailPhone.media.file_name ? detailPhone.media.file_name : '-'" disabled/>
                        </el-form-item>
                        <el-form-item label="Created Date">
                            <el-input :value="detailPhone.created_at ? formatDate(detailPhone.created_at) : '-'" disabled/>
                        </el-form-item>
                        <el-form-item label="Created By">
                            <el-input :value="detailPhone.admin && detailPhone.admin.username ? detailPhone.admin.username : '-'" disabled/>
                        </el-form-item>
                    </el-form>
                </el-card>
                <el-card class="mt-20">
                    <template>
                        <h3 class="mb-10">List Market Area</h3>
                        <el-card
                            v-for="(item, idx) in detailPhone.master_discount_markets"
                            :key="idx"
                            class="mb-10"
                        >
                            <el-form :inline="true" label-position="top" class="demo-form-inline">
                                <el-form-item label="Market Area" class="mb-5 mr-5">
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="item.master_market_area.name"
                                    />
                                </el-form-item>
                                <el-form-item label="Authentication" class="mb-5 mr-5">
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="`${item.master_discount_market_detail_amount.authentication_type === 'currency' ? 'Rp' : ''} ${item.master_discount_market_detail_amount.authentication_amount} ${item.master_discount_market_detail_amount.authentication_type === 'percentage' ? '%' : ''}`"
                                    /><br/>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="formatPrice(item.master_discount_market_detail_amount.authentication_price_after_discount)"
                                    />
                                </el-form-item>
                                <el-form-item label="Marketing" class="mb-5 mr-5">
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="`${item.master_discount_market_detail_amount.marketing_type === 'currency' ? 'Rp' : ''} ${item.master_discount_market_detail_amount.marketing_amount} ${item.master_discount_market_detail_amount.marketing_type === 'percentage' ? '%' : ''}`"
                                    /><br/>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="formatPrice(item.master_discount_market_detail_amount.marketing_price_after_discount)"
                                    />
                                </el-form-item>
                                <el-form-item label="Utility" class="mb-5 mr-5">
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="`${item.master_discount_market_detail_amount.utility_type === 'currency' ? 'Rp' : ''} ${item.master_discount_market_detail_amount.utility_amount} ${item.master_discount_market_detail_amount.utility_type === 'percentage' ? '%' : ''}`"
                                    /><br/>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="formatPrice(item.master_discount_market_detail_amount.utility_price_after_discount)"
                                    />
                                </el-form-item>
                                <el-form-item label="Service" class="mb-5 mr-5">
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="`${item.master_discount_market_detail_amount.service_type === 'currency' ? 'Rp' : ''} ${item.master_discount_market_detail_amount.service_amount} ${item.master_discount_market_detail_amount.service_type === 'percentage' ? '%' : ''}`"
                                    /><br/>
                                    <el-input
                                        type="text"
                                        size="medium"
                                        style="width:150px;"
                                        disabled
                                        :value="formatPrice(item.master_discount_market_detail_amount.service_price_after_discount)"
                                    />
                                </el-form-item>
                            </el-form>
                        </el-card>
                    </template>
                </el-card>
            </el-row>
        </el-dialog>

        <!-- modal dialog add market area -->
        <el-dialog title="Add Market Area" :visible.sync="dialogAddMarketArea" v-loading="loadingDetailAddPriceWaba" id="html-2-pdfwrapper" width="65%">
            <el-card class="mt-20">
                <template>
                    <el-card>
                        <el-form :inline="true" label-position="top" class="demo-form-inline">
                            <el-form-item label="Market Area" class="mb-5 mr-5">
                                <el-select
                                    clearable
                                    v-model="addArea.code"
                                    placeholder="Market Area"
                                    style="width:150px;"
                                    filterable
                                    remote
                                    reserve-keyword
                                    remote-show-suffix
                                    size="medium"
                                >
                                    <el-option
                                        v-for="(item, idx) in listMarketArea"
                                        :label="item.name"
                                        :value="item.code"
                                        :disabled="isMarketExists(item)"
                                        :key="idx"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Price Type" class="mb-5 mr-5">
                                <label>META Price</label><br/>
                                <label>DKD Price</label>
                            </el-form-item>
                            <el-form-item label="Authentication" class="mb-5 mr-5">
                                <el-input
                                    placeholder="Meta Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    v-model="addArea.meta_price.authentication_price"
                                    @keypress.native="numberOnly"
                                    :disabled="!addArea.code"
                                /><br/>
                                <el-input
                                    v-model="addArea.dkd_price.authentication_price"
                                    placeholder="DKD Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    @keypress.native="numberOnly"
                                    :disabled="!addArea.code"
                                />
                            </el-form-item>
                            <el-form-item label="Marketing" class="mb-5 mr-5">
                                <el-input
                                    placeholder="Meta Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    v-model="addArea.meta_price.marketing_price"
                                    @keypress.native="numberOnly"
                                    :disabled="!addArea.code"
                                /><br/>
                                <el-input
                                    v-model="addArea.dkd_price.marketing_price"
                                    placeholder="DKD Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    @keypress.native="numberOnly"
                                    :disabled="!addArea.code"
                                />
                            </el-form-item>
                            <el-form-item label="Utility" class="mb-5 mr-5">
                                <el-input
                                    placeholder="Meta Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    v-model="addArea.meta_price.utility_price"
                                    @keypress.native="numberOnly"
                                    :disabled="!addArea.code"
                                /><br/>
                                <el-input
                                    v-model="addArea.dkd_price.utility_price"
                                    placeholder="DKD Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    @keypress.native="numberOnly"
                                    :disabled="!addArea.code"
                                />
                            </el-form-item>
                            <el-form-item label="Service" class="mb-5 mr-5">
                                <el-input
                                    placeholder="Meta Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    v-model="addArea.meta_price.service_price"
                                    @keypress.native="numberOnly"
                                    :disabled="!addArea.code"
                                /><br/>
                                <el-input
                                    placeholder="DKD Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    v-model="addArea.dkd_price.service_price"
                                    @keypress.native="numberOnly"
                                    :disabled="!addArea.code"
                                />
                            </el-form-item>
                            <el-form-item label="Status" class="mb-5 mr-5">
                                <el-select
                                    placeholder="Status"
                                    style="width:150px;"
                                    size="medium"
                                    v-model="addArea.status"
                                    :disabled="!addArea.code"
                                >
                                    <el-option
                                        v-for="(item, idx) in statusMarket"
                                        :label="item.label"
                                        :value="item.value"
                                        :key="idx"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </template>
                <el-row class="mt-20">
                    <el-button :disabled="!addArea.code" :loading="btnLoadingMarket" @click="createMarketArea()" type="primary">Save</el-button>
                    <el-button @click="cancelDialog('market')" type="danger">Cancel</el-button>
                </el-row>
            </el-card>
        </el-dialog>

        <!-- modal dialog edit market area -->
        <el-dialog title="Edit Market Area" :visible.sync="dialogEditMarketArea" v-loading="loadingDetailEditPriceWaba" id="html-2-pdfwrapper" width="65%">
            <el-card class="mt-20">
                <template>
                    <el-card>
                        <el-form :inline="true" label-position="top" class="demo-form-inline">
                            <el-form-item label="Market Area" class="mb-5 mr-5">
                                <el-select
                                    clearable
                                    v-model="selectedEditMarketArea.code"
                                    placeholder="Market Area"
                                    style="width:150px;"
                                    filterable
                                    remote
                                    reserve-keyword
                                    remote-show-suffix
                                    size="medium"
                                >
                                    <el-option
                                        v-for="(item, idx) in listMarketArea"
                                        :label="item.name"
                                        :value="item.code"
                                        :key="idx"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Price Type" class="mb-5 mr-5">
                                <label>META Price</label><br/>
                                <label>DKD Price</label>
                            </el-form-item>
                            <el-form-item label="Authentication" class="mb-5 mr-5">
                                <el-input
                                    placeholder="Meta Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    v-model="selectedEditMarketArea.market_meta_price.authentication_price"
                                    @keypress.native="numberOnly"
                                /><br/>
                                <el-input
                                    v-model="selectedEditMarketArea.market_dkd_price.authentication_price"
                                    placeholder="DKD Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    @keypress.native="numberOnly"
                                />
                            </el-form-item>
                            <el-form-item label="Marketing" class="mb-5 mr-5">
                                <el-input
                                    placeholder="Meta Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    v-model="selectedEditMarketArea.market_meta_price.marketing_price"
                                    @keypress.native="numberOnly"
                                /><br/>
                                <el-input
                                    v-model="selectedEditMarketArea.market_dkd_price.marketing_price"
                                    placeholder="DKD Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    @keypress.native="numberOnly"
                                />
                            </el-form-item>
                            <el-form-item label="Utility" class="mb-5 mr-5">
                                <el-input
                                    placeholder="Meta Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    v-model="selectedEditMarketArea.market_meta_price.utility_price"
                                    @keypress.native="numberOnly"
                                /><br/>
                                <el-input
                                    v-model="selectedEditMarketArea.market_dkd_price.utility_price"
                                    placeholder="DKD Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    @keypress.native="numberOnly"
                                />
                            </el-form-item>
                            <el-form-item label="Service" class="mb-5 mr-5">
                                <el-input
                                    placeholder="Meta Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    v-model="selectedEditMarketArea.market_meta_price.service_price"
                                    @keypress.native="numberOnly"
                                /><br/>
                                <el-input
                                    placeholder="DKD Price"
                                    type="text"
                                    size="medium"
                                    style="width:150px;"
                                    v-model="selectedEditMarketArea.market_dkd_price.service_price"
                                    @keypress.native="numberOnly"
                                />
                            </el-form-item>
                            <el-form-item label="Status" class="mb-5 mr-5">
                                <el-select
                                    placeholder="Status"
                                    style="width:150px;"
                                    size="medium"
                                    v-model="selectedEditMarketArea.status"
                                >
                                    <el-option
                                        v-for="(item, idx) in statusMarket"
                                        :label="item.label"
                                        :value="item.value"
                                        :key="idx"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </template>
                <el-row class="mt-20">
                    <el-button :loading="btnSaveEditMarket" @click="editMarketArea()" type="primary">Save</el-button>
                    <el-button @click="cancelDialog('editMarket')" type="danger">Cancel</el-button>
                </el-row>
            </el-card>
        </el-dialog>

        <el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
            DAM Corp.
        </el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const _ = require('lodash')
const moment = require('moment')
const countryCodes = require('country-codes-list')
import axios from 'axios'

export default {
    name: 'bussiness_market',
	components: {
	},
	data () {
		return {
            activeTab: 'area',
            uploadUrl: config.baseApi + 'whatsapp/inquiryNumber',
            uploadHeaders: {
                'api-key': this.$store.getters.accessToken,
            },
            uploadedFileList: [],
            loadingTable: false,
            dialogDetailDiscountWaba: false,
            dialogAddDiscountWaba: false,
            dialogAddDiscountPhone: false,
            dialogDetailDiscountPhone: false,
            dialogAddMarketArea: false,
            loadingDetailDiscountPriceWaba: false,
            loadingDetailAddPriceWaba: false,
            loadingDetailAddDiscountPhone: false,
            loadingDetailDiscountPhone: false,
            loadingDetailAddPriceWaba: false,
            periodLimitSelect: [
                {
                    label: 'All',
                    value: ''
                },
                {
                    label: 'To expire in 3 months',
                    value: 3
                },
                {
                    label: 'To expire in 2 months',
                    value: 2
                },
                {
                    label: 'To expire in 1 month',
                    value: 1
                }
            ],
            areaData: [],
            discWabaData: [],
            discPhoneNumberData: [],
            countries: [],
            addMarketArea: {
                addMarket: ''
            },
            selectCompanyPhone: '',
            addDiscPhone: {
                discName: '',
                selectedStartDate: '',
                waba_phone_number: '',
                status: true,
                type: 'phone_number',
                master_discount_markets: [
                    {
                        master_market_area_id: null,
                        master_discount_market_detail_amount: {
                            authentication_amount: null,
                            disc_authentication_amount: null,
                            authentication_type: "",
                            marketing_amount: null,
                            disc_marketing_amount: null,
                            marketing_type: "",
                            utility_amount: null,
                            disc_utility_amount: null,
                            utility_type: "",
                            service_amount: null,
                            disc_service_amount: null,
                            service_type: ""
                        }
                    }
                ]
            },
            addDiscWaba: {
                selectedStartDate: '',
                waba_phone_number: '',
                status: true,
                discName: '',
                type: 'waba',
                master_discount_markets: [
                    {
                        master_market_area_id: null,
                        master_discount_market_detail_amount: {
                            authentication_amount: null,
                            disc_authentication_amount: null,
                            authentication_type: "",
                            marketing_amount: null,
                            disc_marketing_amount: null,
                            marketing_type: "",
                            utility_amount: null,
                            disc_utility_amount: null,
                            utility_type: "",
                            service_amount: null,
                            disc_service_amount: null,
                            service_type: ""
                        }
                    }
                ]
            },
            addArea: {
                code: "",
                name: "",
                status: null,
                meta_price: {
                    marketing_price: null,
                    authentication_price: null,
                    utility_price: null,
                    service_price: null
                },
                dkd_price: {
                    marketing_price: null,
                    authentication_price: null,
                    utility_price: null,
                    service_price: null
                }
            },
            pickerOptions: {
				disabledDate(date) {
                    if (moment(date).isBefore(moment(), 'date')) {
                        return true
                    }
                    return false
                }
			},
            detailWaba: {},
            detailPhone: {},
            optionListMarket: [
                {
                    name: 'Percentage',
                    value: 'percentage'
                },
                {
                    name: 'Currency',
                    value: 'currency'
                }
            ],
            consumenData: [],
            listPhoneNumber: [],
            listMarketArea: [],
            wabaSelectedArea: [],
            phoneSelectedArea: [],
            areaWaba: [],
            areaPhone: [],
            objectUploadFile: {},
            loadingBtnAddWaba: false,
            loadingBtnAddPhone: false,
            statusMarket: [
                {
                    value: true,
                    label: 'Active'
                },
                {
                    value: false,
                    label: 'Not Active'
                }
            ],
            loadingDetailEditPriceWaba: false,
            dialogEditMarketArea: false,
            selectedEditMarketArea: {
                market_meta_price: {
                    authentication_price: 0,
                    marketing_price: 0,
                    utility_price: 0,
                    service_price: 0
                },
                market_dkd_price: {
                    authentication_price: 0,
                    marketing_price: 0,
                    utility_price: 0,
                    service_price: 0
                },
                status: false,
                code: null
            },
            selectPeriodeLimit: [
                {
                    name: 'All',
                    value: ''
                },
                {
                    name: 'To expire in 3 months',
                    value: '3'
                },
                {
                    name: 'To expire in 2 months',
                    value: '2'
                },
                {
                    name: 'To expire in 1 months',
                    value: '1'
                }
            ],
            selectPeriodeLimitPhoneNumber: [
                {
                    name: 'All',
                    value: ''
                },
                {
                    name: 'To expire in 3 months',
                    value: '3'
                },
                {
                    name: 'To expire in 2 months',
                    value: '2'
                },
                {
                    name: 'To expire in 1 months',
                    value: '1'
                }
            ],
            btnSaveEditMarket: false,
            filterWabaId: '',
            filterDiscName: '',
            filterSelectedDateByPhone: '',
            filterCompanyNameByPhone: '',
            filterDiscNameByPhone: '',
            filterPhoneNumberByPhone: '',
            filterPeriodePhoneNumber: '',
            filterPeriode: '',
            searchMarketArea: '',
            totalAreaData: 0,
            currentPage: 1,
            btnSearchLoading: false,
            listCustomer: [],
            listPhoneNumber: [],
            btnLoadingMarket: false,
            fbIdentityWaba: [],
            fbIdentityFbbm: [],
            wabaExpireThree: [],
            wabaExpireTwo: [],
            wabaExpireOne: [],
            phoneExpireThree: [],
            phoneExpireTwo: [],
            phoneExpireOne: [],
            currentPageWaba: 1,
            currentPagePhone: 1,
            totalWabaData: 0,
            totalPhoneData: 0,
            wabaSummary: {},
            phoneNumberSummary: {},
            loadingPage: false,
            listAreaData: [],
            discListWaba: [],
            areaAllData: []
		}
	},
	methods: {
        log(data) {
            console.log(data, " <<log");
        },
        isMarketSelected(type) {
            if (type == 'waba') {
                let data = this.addDiscWaba.master_discount_markets;
                let notEmpty = data.some(el => !el.master_market_area_id);

                return notEmpty;
            } else if (type == 'phone') {
                let data = this.addDiscPhone.master_discount_markets;
                let notEmpty = data.some(el => !el.master_market_area_id);

                return notEmpty;
            }

            return false;
        },
        isChoosedMarket(data, type) {

            if (type == 'waba') {
                let marketAreaWaba = this.addDiscWaba.master_discount_markets;
                if (marketAreaWaba.length > 0) {
                    let exist = marketAreaWaba.some(el => el.master_market_area_id === data.id)
    
                    return exist;
                }
            } else if (type == 'phone') {
                let marketAreaPhone = this.addDiscPhone.master_discount_markets;
                if (marketAreaPhone.length > 0) {
                    let exist = marketAreaPhone.some(el => el.master_market_area_id === data.id)
    
                    return exist;
                }
            }

            return false;
        },
        isMarketExists(data) {
            let listArea = this.areaAllData;

            if (listArea.length > 0) {
                let exist = listArea.some(el => el.code === data.code)
                return exist
            }
            return false
        },
        clearInputCurrency(tab, type, idx) {
            if (type === 'addAuth') {
                if (this.areaData.length > 0 && tab === 'waba') {
                    this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.disc_authentication_amount = null;
                    this.areaAllData[idx].market_dkd_price.authentication_price = this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.authentication_amount
                } else if (this.areaPhone.length > 0 && tab === 'phone') {
                    this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.disc_authentication_amount = null;
                    this.areaPhone[idx].market_dkd_price.authentication_price = this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.authentication_amount
                }
            } else if (type === 'addMarketing') {
                if (this.areaData.length > 0 && tab === 'waba') {
                    this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.disc_marketing_amount = null;
                    this.areaAllData[idx].market_dkd_price.marketing_price = this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.marketing_amount
                } else if (this.areaPhone.length > 0 && tab === 'phone') {
                    this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.disc_marketing_amount = null;
                    this.areaPhone[idx].market_dkd_price.marketing_price = this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.marketing_amount
                }
            } else if (type === 'addUtility') {
                if (this.areaData.length > 0 && tab === 'waba') {
                    this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.disc_utility_amount = null;
                    this.areaAllData[idx].market_dkd_price.utility_price = this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.utility_amount
                } else if (this.areaPhone.length > 0 && tab === 'phone') {
                    this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.disc_utility_amount = null;
                    this.areaPhone[idx].market_dkd_price.utility_price = this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.utility_amount
                }
            } else if (type === 'addService') {
                if (this.areaData.length > 0 && tab === 'waba') {
                    this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.disc_service_amount = null;
                    this.areaAllData[idx].market_dkd_price.service_price = this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.service_amount
                } else if (this.areaPhone.length > 0 && tab === 'phone') {
                    this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.disc_service_amount = null;
                    this.areaPhone[idx].market_dkd_price.service_price = this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.service_amount
                }
            }
        },
        formatPrice(val){
			return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(val);
		},
        formatNumber(value) {
			return value.toLocaleString('id-ID');
		},
        async paginateAreaData(page){
			this.currentPage = page
			await this.getArea(this.currentPage)
		},
        async paginateWabaData(page){
            this.currentPageWaba = page
            await this.getDisc(this.currentPageWaba, 'waba')
		},
        async paginatePhoneData(page){
            this.currentPagePhone = page
            await this.getDisc(this.currentPagePhone, 'phone_number')
		},
        filterCompanyName() {
            this.listPhoneNumber = [];
            this.listCustomer.map(item => {
                if (item.customer_id === this.filterCompanyNameByPhone && item.customer_pic_phone) {
                    let temp = {
                        phone_number: item.customer_pic_phone
                    }
                    this.listPhoneNumber.push(temp);
                }
            })
        },
        cancelDialog(type = '') {
            if(type === 'waba') {
                this.dialogAddDiscountWaba = false;
                this.clear('disc_waba')
            } else if (type === 'phone_number') {
                this.dialogAddDiscountPhone = false;
                this.clear('disc_phone');
            } else if (type === 'market') {
                this.dialogAddMarketArea = false;
                this.clear('market');
            } else if (type === 'editMarket') {
                this.dialogEditMarketArea=false;
                this.selectedEditMarketArea = {
                    market_meta_price: {
                        authentication_price: 0,
                        marketing_price: 0,
                        utility_price: 0,
                        service_price: 0
                    },
                    market_dkd_price: {
                        authentication_price: 0,
                        marketing_price: 0,
                        utility_price: 0,
                        service_price: 0
                    },
                    status: false,
                    code: null
                };
            }
        },
        addMarketAreaModal() {
            this.dialogAddMarketArea=true;
            this.clear('market');
        },
        addWabaDiscount() {
            this.dialogAddDiscountWaba=true;
            this.clear('disc_waba');
        },
        addPhoneDiscModal() {
            this.dialogAddDiscountPhone=true;
            this.clear('disc_phone');
        },
        selectedAreaWabaPhone(type = '', idx) {
            if (type === 'waba') {
                this.areaAllData.map(item => {
                    if (item.id === this.addDiscWaba.master_discount_markets[idx].master_market_area_id) {
                        this.areaWaba.splice(idx, 0, item);
                        let authentication = this.areaWaba[idx].market_dkd_price.authentication_price;
                        let marketing = this.areaWaba[idx].market_dkd_price.marketing_price;
                        let utility = this.areaWaba[idx].market_dkd_price.utility_price;
                        let service = this.areaWaba[idx].market_dkd_price.service_price;

                        this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.authentication_amount = authentication;
                        this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.marketing_amount = marketing;
                        this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.utility_amount = utility;
                        this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.service_amount = service;
                    }
                })
            } else if (type === 'phone_number') {
                this.areaAllData.map(item => {
                    if (item.id === this.addDiscPhone.master_discount_markets[idx].master_market_area_id) {
                        this.areaPhone.splice(idx, 0, item);
                        let authentication = this.areaPhone[idx].market_dkd_price.authentication_price;
                        let marketing = this.areaPhone[idx].market_dkd_price.marketing_price;
                        let utility = this.areaPhone[idx].market_dkd_price.utility_price;
                        let service = this.areaPhone[idx].market_dkd_price.service_price;

                        this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.authentication_amount = authentication;
                        this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.marketing_amount = marketing;
                        this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.utility_amount = utility;
                        this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.service_amount = service;
                    }
                })
            }
        },
        calculation(type = '', amount, type_amount, idx, market_price, price_type) {
            let rumus;
            if(type_amount === 'percentage') {
                rumus = amount / 100 * market_price;
            } else if (type_amount === 'currency') {
                rumus = amount
            }
            
            if(type === 'waba') {
                if(price_type === 'authentication') {
                    let result = market_price - rumus;
                    // this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.authentication_amount = result < 0 ? 0 : result;
                    this.areaWaba[idx].market_dkd_price.authentication_price = result < 0 ? 0 : result;
                } else if(price_type === 'marketing') {
                    let result = market_price - rumus;
                    // this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.marketing_amount = result < 0 ? 0 : result;
                    this.areaWaba[idx].market_dkd_price.marketing_price = result < 0 ? 0 : result;
                } else if (price_type === 'utility') {
                    let result = market_price - rumus;
                    // this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.utility_amount = result < 0 ? 0 : result;
                    this.areaWaba[idx].market_dkd_price.utility_price = result < 0 ? 0 : result;
                } else if (price_type === 'service') {
                    let result = market_price - rumus;
                    // this.addDiscWaba.master_discount_markets[idx].master_discount_market_detail_amount.service_amount = result < 0 ? 0 : result;
                    this.areaWaba[idx].market_dkd_price.service_price = result < 0 ? 0 : result;
                }
            } else if (type === 'phone_number') {
                if(price_type === 'authentication') {
                    let result = market_price - rumus;
                    // this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.authentication_amount = result < 0 ? 0 : result;
                    this.areaPhone[idx].market_dkd_price.authentication_price = result < 0 ? 0 : result;
                } else if(price_type === 'marketing') {
                    let result = market_price - rumus;
                    // this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.marketing_amount = result < 0 ? 0 : result;
                    this.areaPhone[idx].market_dkd_price.marketing_price = result < 0 ? 0 : result;
                } else if (price_type === 'utility') {
                    let result = market_price - rumus;
                    // this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.utility_amount = result < 0 ? 0 : result;
                    this.areaPhone[idx].market_dkd_price.utility_price = result < 0 ? 0 : result;
                } else if (price_type === 'service') {
                    let result = market_price - rumus;
                    // this.addDiscPhone.master_discount_markets[idx].master_discount_market_detail_amount.service_amount = result < 0 ? 0 : result;
                    this.areaPhone[idx].market_dkd_price.service_price = result < 0 ? 0 : result;
                }
            }
        },
        numberOnly(e) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Comma
                (e.keyCode === 44) ||
                // Allow: Period
                (e.keyCode === 46) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,46,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        formatDate(date){
            var formated = moment(date).format('YYYY-MM-DD');
            return formated;
        },
        handleExceed(files, fileList) {
		},
		beforeRemove(file, fileList) {
		},
		handlePreview(file) {
		},
		handleRemove(file, fileList) {
		},
        beforeUploadMedia(object){
            if(["application/pdf"].indexOf(object.type)==-1){
				this.$swal(this.$t('error'), "Media extension not match (.pdf)", "warning")
				return false
			}
		},
        async renderMedia(object){

            if(object.file.size >= 104857600){
                this.closeDialog()
                this.$swal(this.$t('error'), "Maximum file upload size is 100 MB", "warning")
                return
			}

			this.objectUploadFile = object.file;
        },
        async uploadMedia(id) {
            let formData = new FormData();
            formData.append('id', id)
            formData.append('files', this.objectUploadFile)
            formData.append('source', 'discount')
            this.loadingBtnAddPhone=true;
            this.loadingBtnAddWaba=true;

            let apiOptions = {
                timeout: 60000 * 5,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            
            await axios.post(config.baseApi + 'master-media/upload', formData, apiOptions).then(resp => {
                var status =
                    resp &&
                    resp.data &&
                    resp.data.ec
                        ? resp.data.ec
                        : null;
                
                if (status === 200) {
                    this.$swal(this.$t('success'), this.$t('success'), "success");
                    this.dialogAddDiscountPhone=false;
                    this.dialogAddDiscountWaba=false;
                    this.loadingBtnAddPhone=false;
                    this.loadingBtnAddWaba=false;
                    this.getDisc(1, 'waba');
                    this.getDisc(1, 'phone_number');
                    this.getWabaPhoneSummary('waba');
                    this.getWabaPhoneSummary('phone_number');
                    this.clear('disc_waba');
                    this.clear('disc_phone');
                } else {
                    this.$swal(this.$t('error'), 'Failed to send data!', "error");
                    this.dialogAddDiscountWaba=false;
                    this.dialogAddDiscountPhone=false;
                    this.loadingBtnAddPhone=false;
                    this.loadingBtnAddWaba=false;
                }

                this.areaWaba = [];
                this.areaPhone = [];
            }).catch(err => {
                console.error(err);
            })
        },
        toManagePrefix(id, market_name) {
            this.$router.push(`/bussiness/market/prefix/${id}/${market_name}`);
        },
        companySelected() {
            var id = this.selectCompanyPhone ? this.selectCompanyPhone : this.filterCompanyNameByPhone;
            this.loadWA(id);
        },
        addMarketDiscPhoneWaba(type = '') {
            var data = {
                master_market_area_id: null,
                master_discount_market_detail_amount: {
                    authentication_amount: null,
                    disc_authentication_amount: null,
                    authentication_type: "",
                    marketing_amount: null,
                    disc_marketing_amount: null,
                    marketing_type: "",
                    utility_amount: null,
                    disc_utility_amount: null,
                    utility_type: "",
                    service_amount: null,
                    disc_service_amount: null,
                    service_type: ""
                }
            }

            let dkd_price = {
                market_dkd_price: {
                    authentication_price: 0,
                    id: null,
                    marketing_price: 0,
                    master_market_area_id: 0,
                    service_price: 0,
                    utility_price: 0
                }
            }

            if(type === 'waba') {
                this.addDiscWaba.master_discount_markets.push(data);
                this.areaWaba.push(dkd_price);
            } else if (type === 'phone_number') {
                this.addDiscPhone.master_discount_markets.push(data);
                this.areaPhone.push(dkd_price);
            }
        },
        deleteMarketAreaDisc(idx, type = '') {
            if (type === 'waba') {
                this.addDiscWaba.master_discount_markets.splice(idx, 1);
                this.areaWaba.splice(idx, 1);
            } else if (type === 'phone_number') {
                this.addDiscPhone.master_discount_markets.splice(idx, 1);
                this.areaPhone.splice(idx, 1);
            }
        },
        async getArea(page = 1){
            this.loadingPage=true;
            let param = {
                q: this.searchMarketArea,
                page: page,
                limit: 20
            }

            await api({
                method: 'get',
                url:config.baseApi+'master-market-area',
                params: param
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];
                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                let total =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.total
                        ? result.data.data.total
                        : 0;

                if(status === 200) {
                    this.areaData = data;
                    this.totalAreaData = total;
                }
                this.loadingPage=false;
            }).catch(error => {
                console.error("Failed : " + error);
                this.loadingPage=false;
            })
	    },
        async getAllArea(page = 1){
            let param = {
                q: this.searchMarketArea,
                page: page,
                limit: 1000
            }

            await api({
                method: 'get',
                url:config.baseApi+'master-market-area',
                params: param
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];

                this.areaAllData = data;
            }).catch(error => {
                console.error("Failed : " + error);
            })
	    },
        async listGetArea(){
            let param = {
                limit: 1000
            }

            await api({
                method: 'get',
                url:config.baseApi+'master-market-area',
                params: param
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];
                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;

                if(status === 200) {
                    this.listAreaData = data;
                }
                this.loadingPage=false;
            }).catch(error => {
                console.error("Failed : " + error);
            })
	    },
        async deleteArea(id, name){
            await this.$swal({
                title: `Are you sure want to delete this ${name} area?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                api({
                    method: 'delete',
                    url: config.baseApi+`master-market-area/${id}`,
                }).then(result => {
                    const status =
                        result &&
                        result.data &&
                        result.data.ec
                            ? result.data.ec
                            : null;

                    if(status === 200) {
                        this.getArea();
                        this.$swal(this.$t('success'), this.$t('success'), "success")
                    }
                    this.currentPage=1;
                }).catch(error => {
                    console.error("Failed : " + error);
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                })
            }).catch(err => {
                console.log(err);
            })
        },
        async getDisc(page = 1, type = ''){
            this.btnSearchLoading=true;
            var params = {
                type: type,
                q: '',
                periode: '',
                phone_number: '',
                customer_id: '',
                page: page,
                limit: 20
            };

            if(type === 'waba') {
                params.q = this.filterDiscName;
                params.phone_number = this.filterWabaId;
                params.periode = this.filterPeriode;
            } else if (type === 'phone_number') {
                params.q = this.filterDiscNameByPhone;
                params.periode = this.filterPeriodePhoneNumber;
                params.phone_number = this.filterPhoneNumberByPhone;
                params.customer_id = this.filterCompanyNameByPhone;
            }

            await api({
                method: 'get',
                url:config.baseApi+'master-discount',
                params
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];
                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                let total =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.total
                        ? result.data.data.total
                        : 0;

                let today = new Date();

                if(status === 200) {
                    if (type === 'waba') {
                        this.discWabaData = data;
                        this.totalWabaData = total;
                    } else if (type === 'phone_number') {
                        this.discPhoneNumberData = data;
                        this.totalPhoneData = total;
                    }
                }
                this.btnSearchLoading=false;
            }).catch(error => {
                this.btnSearchLoading=false;
                console.error("Failed : " + error);
            })
	    },
        async getListDisc(type = ''){
            var params = {
                type: type,
                limit: 1000
            };

            await api({
                method: 'get',
                url:config.baseApi+'master-discount',
                params
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];
                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;

                if(status === 200) {
                    this.discListWaba = data;
                }
            }).catch(error => {
                console.error("Failed : " + error);
            })
	    },
        async deleteDiscWabaPhone(id, name, type = ''){
            await this.$swal({
                title: `Are you sure want to delete ${name}?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                api({
                    method: 'delete',
                    url: config.baseApi+`master-discount/${id}`,
                }).then(result => {
                    const status =
                        result &&
                        result.data &&
                        result.data.ec
                            ? result.data.ec
                            : null;

                    if(status === 200) {
                        this.getDisc(1, type);
                        this.getWabaPhoneSummary('waba');
                        this.getWabaPhoneSummary('phone_number');
                        this.$swal(this.$t('success'), this.$t('success'), "success")
                    }
                    this.currentPageWaba=1;
                    this.currentPagePhone=1;
                }).catch(error => {
                    console.error("Failed : " + error);
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                })
            }).catch(err => {
                console.log(err);
            })
        },
        async detailPhoneWaba(id, type = '') {
            await api({
                method: 'get',
                url:config.baseApi+'master-discount/'+id
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data
                        ? result.data.data
                        : [];
                        
                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;

                if(status === 200) {
                    if (type === 'waba') {
                        this.dialogDetailDiscountWaba=true;
                        this.detailWaba = data;
                    } else if (type === 'phone_number') {
                        this.dialogDetailDiscountPhone=true;
                        this.detailPhone = data;
                    }
                }
            }).catch(error => {
                console.error("Failed : " + error);
            })
        },
        async getConsumen(){
			await api({
				method: "get",
				url: config.baseApi + "consumen",
				params: {
                    customer_type: 2,
					query_by: 'waba_number',
                    dropdown: true
				}
			}).then(resp => {
                const status =
                    resp &&
                    resp.data &&
                    resp.data.ec
                        ? resp.data.ec
                        : null;
                const data =
                    resp &&
                    resp.data &&
                    resp.data.data &&
                    resp.data.data.consumen
                        ? resp.data.data.consumen
                        : [];
				if(status == 200){
                    this.consumenData = data;
				}
			}).catch(err => {
				console.log("failed", err)
			})
		},
        async loadWA(id) {
			await api({
				method: 'post',
				url: config.baseApi +'user/'+id+'/detail_number'
			}).then(result => {
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                const data =
                    result &&
                    result.data &&
                    result.data.data
                        ? result.data.data
                        : [];
				if(status == 200){
                    this.listPhoneNumber = data;
				} else {
                    this.listPhoneNumber = [];
                }
			}).catch(error => {
                console.log('Error:', error)
			})
		},
        async createDiscWabaPhone(type = '') {
            var tempData = {
                customer_id: "",
                waba_phone_number: "",
                name: "",
                start_period: "",
                end_period: "",
                status: true,
                type: "",
                master_discount_markets: [
                    {
                        master_market_area_id: null,
                        master_discount_market_detail_amount: {
                            authentication_amount: null,
                            authentication_type: "",
                            marketing_amount: null,
                            marketing_type: "",
                            utility_amount: null,
                            utility_type: "",
                            service_amount: null,
                            service_type: ""
                        }
                    }
                ]
            }

            if (type == 'phone_number') {
                var data = [];
                tempData = {
                    customer_id: this.selectCompanyPhone,
                    waba_phone_number: this.addDiscPhone.waba_phone_number,
                    name: this.addDiscPhone.discName,
                    start_period: moment(this.addDiscPhone.selectedStartDate[0]).format('YYYY-MM-DD'),
                    end_period: moment(this.addDiscPhone.selectedStartDate[1]).format('YYYY-MM-DD'),
                    status: true,
                    type: type,
                    master_discount_markets: data
                }

                this.addDiscPhone.master_discount_markets.map(item => {
                    let arrData = {
                        master_market_area_id: item.master_market_area_id,
                        master_discount_market_detail_amount: {
                            authentication_amount: item.master_discount_market_detail_amount.disc_authentication_amount,
                            authentication_type: item.master_discount_market_detail_amount.authentication_type,
                            marketing_amount: item.master_discount_market_detail_amount.disc_marketing_amount,
                            marketing_type: item.master_discount_market_detail_amount.marketing_type,
                            utility_amount: item.master_discount_market_detail_amount.disc_utility_amount,
                            utility_type: item.master_discount_market_detail_amount.utility_type,
                            service_amount: item.master_discount_market_detail_amount.disc_service_amount,
                            service_type: item.master_discount_market_detail_amount.service_type
                        }
                    }

                    data.push(arrData);
                })

            } else if (type == 'waba') {
                var data = [];
                tempData = {
                    customer_id: '',
                    waba_phone_number: this.addDiscWaba.waba_phone_number,
                    name: this.addDiscWaba.discName,
                    start_period: moment(this.addDiscWaba.selectedStartDate[0]).format('YYYY-MM-DD'),
                    end_period: moment(this.addDiscWaba.selectedStartDate[1]).format('YYYY-MM-DD'),
                    status: true,
                    type: type,
                    master_discount_markets: data
                }

                this.addDiscWaba.master_discount_markets.map(item => {
                    let arrData = {
                        master_market_area_id: item.master_market_area_id,
                        master_discount_market_detail_amount: {
                            authentication_amount: item.master_discount_market_detail_amount.disc_authentication_amount,
                            authentication_type: item.master_discount_market_detail_amount.authentication_type,
                            marketing_amount: item.master_discount_market_detail_amount.disc_marketing_amount,
                            marketing_type: item.master_discount_market_detail_amount.marketing_type,
                            utility_amount: item.master_discount_market_detail_amount.disc_utility_amount,
                            utility_type: item.master_discount_market_detail_amount.utility_type,
                            service_amount: item.master_discount_market_detail_amount.disc_service_amount,
                            service_type: item.master_discount_market_detail_amount.service_type
                        }
                    }

                    data.push(arrData);
                })
            }
            
            if (!this.validation(type, tempData)) {
                this.loadingBtnAddPhone=true;
                this.loadingBtnAddWaba=true;
                await api({
                    method: 'post',
                    url:config.baseApi+'master-discount',
                    data: tempData
                }).then(result => {
                    var data =
                        result &&
                        result.data &&
                        result.data.data
                            ? result.data.data
                            : [];
                    var id =
                        data &&
                        data.id
                            ? data.id
                            : '';
                    var status =
                        result &&
                        result.data &&
                        result.data.ec
                            ? result.data.ec
                            : null;
                    var message =
                        result &&
                        result.data &&
                        result.data.message
                            ? result.data.message
                            : null;
                    if(status === 200) {
                        if(type === 'phone_number') {
                            this.uploadMedia(id);
                        } else if (type === 'waba') {
                            this.uploadMedia(id);
                        }
                    } else {
                        this.$swal(this.$t('error'), message, "error");
                    }

                    this.currentPageWaba=1;
                    this.currentPagePhone=1;
                }).catch(error => {
                    console.error("Failed : " + error);
                })
                this.loadingBtnAddPhone=false;
                this.loadingBtnAddWaba=false;
            }
        },
        async createMarketArea() {
            var data = this.addArea;
            if (!this.validation('market', data)) {
                this.btnLoadingMarket=true;
                this.listMarketArea.map(item => {
                    if (item.code === this.addArea.code) {
                        data.name = item.name;
                    }
                })
    
                await api({
                    method: 'post',
                    url:config.baseApi+'master-market-area',
                    data: data
                }).then(result => {
                    var status =
                        result &&
                        result.data &&
                        result.data.ec
                            ? result.data.ec
                            : null;
                    if(status === 200) {
                        this.getArea();
                        this.$swal(this.$t('success'), this.$t('success'), "success");
                        this.dialogAddMarketArea = false;
                        this.clear('market');
                    } else {
                        this.$swal(this.$t('error'), 'Failed to add market area!', "error");
                    }
                    this.currentPage=1;
                }).catch(error => {
                    console.error("Failed : " + error);
                })
            }
            this.btnLoadingMarket=false;
        },
        async detailMarketArea(id) {
            this.selectedEditMarketArea = {
                market_meta_price: {
                    authentication_price: 0,
                    marketing_price: 0,
                    utility_price: 0,
                    service_price: 0
                },
                market_dkd_price: {
                    authentication_price: 0,
                    marketing_price: 0,
                    utility_price: 0,
                    service_price: 0
                },
                status: false,
                code: null
            };

            await api({
                method: 'get',
                url:config.baseApi+`master-market-area/${id}`
            }).then(result => {
                let data =
                    result &&
                    result.data &&
                    result.data.data
                        ? result.data.data
                        : {};
                let status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;

                if (status === 200) {
                    this.selectedEditMarketArea = data;
                    this.dialogEditMarketArea=true;
                } else {
                    this.$message.error({
                        showClose: false,
                        message: 'Failed to get detail market area'
                    });
                }
            }).catch(error => {
                console.error("Failed : " + error);
            })
        },
        async editMarketArea() {
            let data = {
                code: this.selectedEditMarketArea.code,
                name: this.selectedEditMarketArea.name,
                status: this.selectedEditMarketArea.status,
                meta_price: {
                    marketing_price: +this.selectedEditMarketArea.market_meta_price.marketing_price,
                    authentication_price: +this.selectedEditMarketArea.market_meta_price.authentication_price,
                    utility_price: +this.selectedEditMarketArea.market_meta_price.utility_price,
                    service_price: +this.selectedEditMarketArea.market_meta_price.service_price
                },
                dkd_price: {
                    marketing_price: +this.selectedEditMarketArea.market_dkd_price.marketing_price,
                    authentication_price: +this.selectedEditMarketArea.market_dkd_price.authentication_price,
                    utility_price: +this.selectedEditMarketArea.market_dkd_price.utility_price,
                    service_price: +this.selectedEditMarketArea.market_dkd_price.service_price
                }
            };
            this.btnSaveEditMarket=true;
            await api({
                method: 'patch',
                url:config.baseApi+`master-market-area/${this.selectedEditMarketArea.id}`,
                data: data
            }).then(result => {
                let status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                if (status === 200) {
                    this.getArea(this.currentPage);
                    this.$swal(this.$t('success'), this.$t('success'), "success");
                    this.dialogEditMarketArea=false;
                } else {
                    this.$swal(this.$t('error'), 'Failed to edit market area!', "error");
                }
            }).catch(error => {
                console.error("Failed : " + error);
            })
            this.btnSaveEditMarket=false;
        },
        clear(tab = '') {
            if(tab === 'market') {
                this.addArea = {
                    code: "",
                    name: "",
                    meta_price: {
                        marketing_price: null,
                        authentication_price: null,
                        utility_price: null,
                        service_price: null
                    },
                    dkd_price: {
                        marketing_price: null,
                        authentication_price: null,
                        utility_price: null,
                        service_price: null
                    }
                }
            } else if (tab === 'disc_phone') {
                this.objectUploadFile = {};
                this.addDiscPhone.selectedStartDate = '',
                this.addDiscPhone.waba_phone_number = '',
                this.addDiscPhone.status = true,
                this.addDiscPhone.discName = '',
                this.addDiscPhone.type = 'phone_number',
                this.addDiscPhone.master_discount_markets = [
                    {
                        master_market_area_id: null,
                        master_discount_market_detail_amount: {
                            authentication_amount: null,
                            disc_authentication_amount: null,
                            authentication_type: "",
                            marketing_amount: null,
                            disc_marketing_amount: null,
                            marketing_type: "",
                            utility_amount: null,
                            disc_utility_amount: null,
                            utility_type: "",
                            service_amount: null,
                            disc_service_amount: null,
                            service_type: ""
                        }
                    }
                ]
                this.areaPhone = []
            } else if (tab === 'disc_waba') {
                this.objectUploadFile = {};
                this.addDiscWaba.selectedStartDate = '',
                this.addDiscWaba.waba_phone_number = '',
                this.addDiscWaba.status = true,
                this.addDiscWaba.discName = '',
                this.addDiscWaba.type = 'phone_number',
                this.addDiscWaba.master_discount_markets = [
                    {
                        master_market_area_id: null,
                        master_discount_market_detail_amount: {
                            authentication_amount: null,
                            disc_authentication_amount: null,
                            authentication_type: "",
                            marketing_amount: null,
                            disc_marketing_amount: null,
                            marketing_type: "",
                            utility_amount: null,
                            disc_utility_amount: null,
                            utility_type: "",
                            service_amount: null,
                            disc_service_amount: null,
                            service_type: ""
                        }
                    }
                ]
                this.areaWaba = []
            }
        },
        async getListMarket(){
			await api({
				method: "get",
				url: config.baseApi + "data/market-area"
			}).then(resp => {
                const status =
                    resp &&
                    resp.data &&
                    resp.data.ec
                        ? resp.data.ec
                        : null;
                const data =
                    resp &&
                    resp.data &&
                    resp.data.data &&
                    resp.data.data.rows
                        ? resp.data.data.rows
                        : [];
				if(status == 200){
                    this.listMarketArea = data;
				}
			}).catch(err => {
				console.log("failed", err)
			})
		},
        validation(type = '', data) {
            let allFilled = false
            if (type === 'market') {
                if (!data.code) {
                    this.$message.error({
                        showClose: false,
                        message: 'Please choose market area!'
                    });
                    allFilled = true
                } else if (
                    data.meta_price.authnetication_price === null ||
                    data.meta_price.marketing_price === null ||
                    data.meta_price.utility_price === null ||
                    data.meta_price.service_price === null ||
                    data.dkd_price.authentication_price === null ||
                    data.dkd_price.marketing_price === null ||
                    data.dkd_price.utility_price === null ||
                    data.dkd_price.service_price === null
                ) {
                    this.$message.error({
                        showClose: false,
                        message: 'Please fill all inputs!'
                    });
                    allFilled = true
                }
            } else if (type === 'waba') {
                if (
                    data.selectedStartDate === '' ||
                    data.waba_phone_number === '' ||
                    data.discName === ''
                ) {
                    this.$message.error({
                        showClose: false,
                        message: 'Please fill all inputs!'
                    });
                    allFilled = true
                }
                data.master_discount_markets.map(item => {
                    if(
                        item.master_discount_market_detail_amount.authentication_type === 'percentage' && item.master_discount_market_detail_amount.disc_authentication_amount > 100 ||
                        item.master_discount_market_detail_amount.marketing_type === 'percentage' && item.master_discount_market_detail_amount.disc_marketing_amount > 100 ||
                        item.master_discount_market_detail_amount.utility_type === 'percentage' && item.master_discount_market_detail_amount.disc_utility_amount > 100 ||
                        item.master_discount_market_detail_amount.service_type === 'percentage' && item.master_discount_market_detail_amount.disc_service_amount > 100
                    ) {
                        this.$message.error({
                            showClose: false,
                            message: 'Percentage cannot more than 100%!'
                        });
                        allFilled = true
                    } else if (
                        item.master_discount_market_detail_amount.authentication_amount === null ||
                        item.master_discount_market_detail_amount.disc_authentication_amount === null ||
                        item.master_discount_market_detail_amount.authentication_type === '' ||
                        item.master_discount_market_detail_amount.marketing_amount === null ||
                        item.master_discount_market_detail_amount.disc_marketing_amount === null ||
                        item.master_discount_market_detail_amount.marketing_type === '' ||
                        item.master_discount_market_detail_amount.utility_amount === null ||
                        item.master_discount_market_detail_amount.disc_utility_amount === null ||
                        item.master_discount_market_detail_amount.utility_type === '' ||
                        item.master_discount_market_detail_amount.service_amount === null ||
                        item.master_discount_market_detail_amount.disc_service_amount === null ||
                        item.master_discount_market_detail_amount.service_type === ''
                    ) {
                        this.$message.error({
                            showClose: false,
                            message: 'Please fill all inputs!'
                        });
                        allFilled = true
                    }
                })
            } else if (type === 'phone_number') {
                if (
                    data.selectedStartDate === '' ||
                    data.waba_phone_number === '' ||
                    data.discName === ''
                ) {
                    this.$message.error({
                        showClose: false,
                        message: 'Please fill all inputs!'
                    });
                    allFilled = true
                }

                data.master_discount_markets.map(item => {
                    if(
                        item.master_discount_market_detail_amount.authentication_type === 'percentage' && item.master_discount_market_detail_amount.disc_authentication_amount > 100 ||
                        item.master_discount_market_detail_amount.marketing_type === 'percentage' && item.master_discount_market_detail_amount.disc_marketing_amount > 100 ||
                        item.master_discount_market_detail_amount.utility_type === 'percentage' && item.master_discount_market_detail_amount.disc_utility_amount > 100 ||
                        item.master_discount_market_detail_amount.service_type === 'percentage' && item.master_discount_market_detail_amount.disc_service_amount > 100
                    ) {
                        this.$message.error({
                            showClose: false,
                            message: 'Percentage cannot more than 100%!'
                        });
                        allFilled = true
                    } else if (
                        item.master_discount_market_detail_amount.authentication_amount === null ||
                        item.master_discount_market_detail_amount.disc_authentication_amount === null ||
                        item.master_discount_market_detail_amount.authentication_type === '' ||
                        item.master_discount_market_detail_amount.marketing_amount === null ||
                        item.master_discount_market_detail_amount.disc_marketing_amount === null ||
                        item.master_discount_market_detail_amount.marketing_type === '' ||
                        item.master_discount_market_detail_amount.utility_amount === null ||
                        item.master_discount_market_detail_amount.disc_utility_amount === null ||
                        item.master_discount_market_detail_amount.utility_type === '' ||
                        item.master_discount_market_detail_amount.service_amount === null ||
                        item.master_discount_market_detail_amount.disc_service_amount === null ||
                        item.master_discount_market_detail_amount.service_type === ''
                    ) {
                        this.$message.error({
                            showClose: false,
                            message: 'Please fill all inputs!'
                        });
                        allFilled = true
                    }
                })
            }
            return allFilled
        },
        async loadConsumen() {
            await api({
                url: config.baseApi + "notification/consumen",
                method: 'get',
                params: {
                    customer_type: 2
                }
            })
            .then(res => {
                let data =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.consumen
                        ? res.data.data.consumen
                        : [];
                let status =
                    res &&
                    res.data &&
                    res.data.ec
                        ? res.data.ec
                        : null;
				if(status === 200){
					this.listCustomer = data;
				}
            })
            .catch(err => {
                console.error(err);
            })
        },
        async getWabaPhoneSummary(type) {
            let param = {
                type: type
            }

            await api({
                url: config.baseApi + "master-discount-summary",
                method: 'get',
                params: param
            })
            .then(res => {
                let data =
                    res &&
                    res.data &&
                    res.data.data
                        ? res.data.data
                        : {}

                if (type === 'waba') {
                    this.wabaSummary = data
                } else {
                    this.phoneNumberSummary = data
                }
            })
            .catch(err => {
                console.error(err);
            })
        },
        async getWabaFbbmId(filter = '') {
            await api({
				url: config.baseApi+'bussiness/get-fb-identity',
				method: 'GET',
				params: {
					all: true,
					filter: filter
				}
			}).then(res => {
                let dataTemp =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.consumen
                        ? res.data.data.consumen
                        : [];
                
                let dataWaba = dataTemp.filter(item => item.type === 'waba_id');
                let dataFbbm = dataTemp.filter(item => item.type === 'fbbm_id');

				switch (filter) {
					case "waba_id":
						this.fbIdentityWaba = this.fbIdentityWaba.concat(dataWaba)
						break;
					case "fbbm_id":
						this.fbIdentityFbbm = this.fbIdentityFbbm.concat(dataFbbm)
						break;
				}
			}).catch(error => {
				console.log(error);
			})
        }
	},
	async mounted(){
        await this.listGetArea();
        await this.getArea();
        await this.getDisc(1, 'waba');
        await this.getDisc(1, 'phone_number');
        await this.getConsumen();
        await this.getListMarket();
        await this.loadConsumen();
        await this.getWabaFbbmId('waba_id');
        await this.getWabaFbbmId('fbbm_id');
        await this.getWabaPhoneSummary('waba');
        await this.getWabaPhoneSummary('phone_number');
        await this.getListDisc('waba');
        await this.getAllArea();
	},
    created(){
        this.countries = countryCodes.all();
    }
}
</script>
<style>
.swal2-container {
	z-index: 10000 !important;
}
</style>
<style lang="scss">
@import '../../assets/scss/_variables';
.chart {
     width: 100%;
     height: 400px;
 }
.page-invoice {
	.toolbar {
		max-width: 794px;
		margin: 0 auto;
		text-align: right;
		margin-bottom: 20px;
	}

	.invoice {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 1123px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.invoice-top {
			overflow: hidden;
			margin-bottom: 30px;

			.logo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: rgba(0, 0, 0, 0.07);
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.invoice-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.project {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.invoice-bottom {
			table {
				width: 100%;
				border-collapse: collapse;

				th {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					border-bottom: 1px solid #EEE;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
					padding-top: 5px;
				}
			}
		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media screen and (max-width: 768px) {
	.page-invoice {
		.invoice {
			.invoice-middle {
				.project {
					display: block;
					width: 100%;
					clear: both;
					padding: 10px 0;
					margin: 0;
				}
			}
			.invoice-bottom {
				table {
					th {
						padding: 5px;
					}

					td {
						padding: 5px;
					}
				}
			}
		}
	}
}

@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}

	.page-invoice {
		.toolbar {
			display: none;
		}

		.invoice {
			box-shadow: none;
			max-width: 100%;
			padding: 0;
		}
	}
}
</style>
<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
